export enum SSOAction {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  GET_ACCESS_TOKEN = "GET_ACCESS_TOKEN",
  GET_ACCOUNT_LIST = "GET_ACCOUNT_LIST",
}

export const USER_TOKEN_KEY = "USER_TOKEN";

export const IFRAME_WIDTH = 500;
export const IFRAME_HEIGHT = 650;
export const IFRAME_TOP = window.screen.height / 2 - IFRAME_WIDTH / 2;
export const IFRAME_LEFT = window.screen.width / 2 - IFRAME_HEIGHT / 2;
export const SSO_ORIGIN =
  process.env.REACT_APP_SSO_ORIGIN || "https://account.tala.xyz";
export const SSO_AUTH_URL = `${SSO_ORIGIN}/oauth2/auth`;
